const handleRealTimeValue = (value: string | null, clockStop: string, clockStart: string) => {
    const clockStopDate = new Date(clockStop.replace(" ", "T"));
    const clockStartDate = new Date(clockStart.replace(" ", "T"));
    const now = new Date();
  
    if (clockStartDate > now) {
      return "未开始";
    } else if (clockStopDate < now) {
      return "已结束";
    } else if (value === null) {
      return "无";
    } else {
      return value;
    }
};
const computePrivilege = (userPrivilege: string, requiredPrivilege: number) => {
  switch (requiredPrivilege) {
    case 0:
      return false;
    case 1:
      return true;
    case 2:
      return userPrivilege === "Club" || userPrivilege === "Admin";
    case 3:
      return userPrivilege === "Admin";
  }
};

export { handleRealTimeValue, computePrivilege }